import { useState, useEffect, useRef, useCallback } from 'react'

import Navbar from '../../components/Navbar/Navbar'
import Select from 'react-select'
import { categoriesPerPage, menuPerPage } from '../../constants/constants'

import iconEdit from '../../assets/icons/iconEdit.svg'

import CreateMenuModal from '../../components/CreateMenu/CreateMenuModal'
import PATH from '../../navigation/path'
import {
  getCategories,
  getCategoryFromCompany,
  getCurrentCategory,
} from '../../redux/actions/categoriesAction'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { CategoriesType, MenuType, ProductType } from '../../redux/actions/types'
import styles from './menuPage.module.css'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import plusIcon from '../../assets/icons/plus.svg'
import iconKebab from '../../assets/icons/IconKebab.svg'
import CreateCategoryModal from '../../components/CreateCategoryModal/CreateCategoryModal'
import CreateProductModal from '../../components/CreateProductModal/CreateProductModal'

import { getAllMenu, getCurrentMenu, getMenuFromCompany } from '../../redux/actions/menuAction'
import AddCategoriesModal from '../../components/AddCatecorisModal/AddCategoriesModal'
import { useMediaQuery } from 'react-responsive'
import DishesCard from '../../components/DishesCard/dishesCard'
import { resetCurrentProduct } from '../../redux/reducers/products/productsSlice'
import { resetCurrentMenu } from '../../redux/reducers/menu/menuSlice'
import { clearCurrentCategory } from '../../redux/reducers/categories/categoriesSlice'

interface MenuCategory {
  category: {
    id: number
    name: string
    description: string
    products: ProductType[]
  }
}

const MenuPage = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
  const [activeOption, setActiveOption] = useState<{ title: string; subTitle: string; id: number }>(
    {
      title: '',
      subTitle: '',
      id: -1,
    },
  )

  const [isCartOpen, setIsCartOpen] = useState(false)
  const [openControl, setOpenControl] = useState(false)
  const [isCreateCategoryOpen, setIsCreateCategoryOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false)
  const controlRef: any = useRef(null)
  const buttonRef: any = useRef(null)
  const [selected, setSelected] = useState<any[]>([])
  const [catSubmited, setCatSubmited] = useState(false)
  const previousCategory = useRef<number | null>(null)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  const { category, currentCategory } = useAppSelector((state) => state.categories)
  const { menu, currentMenu } = useAppSelector((state) => state.menu)

  const { token, userRole } = useAppSelector((state) => state.auth)
  const [editMode, setEditMode] = useState<boolean>(false)
  const [isProductOpen, setIsProductOpen] = useState<boolean>(false)
  const [isMenuEditing, setIsMenuEditing] = useState<boolean>(false)

  const [selectedMenu, setSelectedMenu] = useState<{
    title: string
    description: string
    id: string
    categoryIds: string[]
    menuCategories: string[]
  }>({
    title: '',
    description: '',
    id: '',
    categoryIds: [],
    menuCategories: [],
  })

  useEffect(() => {
    if (!selectedMenu.id) {
      dispatch(resetCurrentMenu())
    }
  }, [selectedMenu])

  const handleEditMode = async () => {
    setEditMode(true)

    await dispatch(getCurrentCategory({ categoryId: String(activeOption.id), token }))
  }

  const handleMenuEditMode = async () => {
    setIsMenuEditing(true)
    await dispatch(getCurrentMenu({ menuId: String(selectedMenu.id), token }))
  }

  const activeItem = async (item: { id: number; title: string; subTitle: string }) => {
    setActiveOption({
      title: item.title,
      subTitle: item.subTitle,
      id: item.id,
    })

    const searchParams = new URLSearchParams(location.search)
    searchParams.set('category', String(item.id)) // Add or update 'category' parameter
    navigate(`${location.pathname}?${searchParams.toString()}`)

    await _getCurrentCategory(item.id)
  }

  const _getCurrentCategory = async (id: number) => {
    await dispatch(getCurrentCategory({ categoryId: String(id), token }))
  }

  const dummyData = (array: CategoriesType[]) => {
    const items: any[] = array.map((category) => {
      return {
        id: category.id,
        title: category.name,
        subTitle: category.description,
        products: category.products,
      }
    })
    return items
  }

  const eventList = dummyData(category.category)

  const handleClickOutside = useCallback((event: MouseEvent | TouchEvent) => {
    if (controlRef.current && !controlRef.current.contains(event.target as Node)) {
      setOpenControl(false)
    }
  }, [])

  useEffect(() => {
    if (openControl) {
      document.addEventListener('pointerdown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)
    }

    return () => {
      document.removeEventListener('pointerdown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [openControl, handleClickOutside])

  useEffect(() => {
    if (location.state) {
      dispatch(
        getCategories({
          token,
          page: currentPage,
          itemsPerPage: categoriesPerPage,
          name: location.state.name,
          menuId: selectedMenu.id,
        }),
      )
    } else {
      if (userRole === 'directorPlace' || userRole === 'directorAgent') {
        dispatch(
          getCategoryFromCompany({
            token,
            page: currentPage,
            itemsPerPage: categoriesPerPage,
          }),
        )
      } else {
        dispatch(
          getCategories({
            token,
            page: currentPage,
            itemsPerPage: categoriesPerPage,
            menuId: selectedMenu.id,
          }),
        )
      }
    }
  }, [dispatch, currentPage, setCurrentPage, categoriesPerPage, catSubmited])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const categoryId = searchParams.get('category')

    if (categoryId && Number(categoryId) !== previousCategory.current) {
      const category = eventList.find((item) => item.id === Number(categoryId))

      if (category) {
        setActiveOption({
          title: category.title,
          subTitle: category.subTitle,
          id: category.id,
        })

        _getCurrentCategory(category.id)
        previousCategory.current = Number(categoryId)
      }
    }
  }, [location.search, eventList])

  const dummyDataMenu = (array: MenuType[]) => {
    const items: any[] = array.map((menu) => {
      return {
        id: menu.id,
        title: menu.name,
        description: menu.description,
        categoryIds: menu.categoryIds,
        menuCategories: menu.menuCategories,
      }
    })
    return items
  }

  const handleSelectChange = async (e: any) => {
    dispatch(
      getAllMenu({
        token,
        page: currentPage,
        itemsPerPage: menuPerPage,
        name: location.state,
      }),
    )
    const selectedMenuId = e.target.value
    const menuItem = menuList.find((item) => item.id === parseInt(selectedMenuId))

    if (menuItem) {
      await dispatch(getCurrentMenu({ menuId: String(menuItem.id), token }))
      setSelectedMenu(menuItem)
      setSelected([menuItem])
    }

    if (menuItem?.menuCategories[0]?.category?.id != undefined) {
      navigate(
        `${PATH.menuPage}${selectedMenuId}?category=${menuItem?.menuCategories[0]?.category?.id}`,
      )
    } else {
      setActiveOption({ title: '', subTitle: '', id: -1 })
      navigate(`${PATH.menuPage}${selectedMenuId}`)
    }
  }

  useEffect(() => {
    if (catSubmited) {
      dispatch(
        getCategories({
          token,
          page: currentPage,
          itemsPerPage: categoriesPerPage,
          menuId: selectedMenu.id,
        }),
      )
      setCatSubmited(false)
    }
  }, [catSubmited, dispatch, currentPage, token])
  useEffect(() => {
    if (location) {
      dispatch(
        getAllMenu({
          token,
          page: currentPage,
          itemsPerPage: menuPerPage,
          name: location.state,
        }),
      )
    } else {
      if (userRole === 'directorPlace' || userRole === 'directorAgent') {
        dispatch(
          getMenuFromCompany({
            token,
            page: currentPage,
            itemsPerPage: menuPerPage,
          }),
        )
      } else {
        dispatch(
          getCategories({
            token,
            page: currentPage,
            itemsPerPage: menuPerPage,
            menuId: selectedMenu.id,
          }),
        )
      }
    }
  }, [dispatch, currentPage, setCurrentPage, menuPerPage])

  const menuList = dummyDataMenu(menu.menu)

  useEffect(() => {
    if (id && !selectedMenu.id) {
      const selectedMenuFromList = menuList.find((item) => item.id === parseInt(id))

      if (selectedMenuFromList) {
        setSelectedMenu(selectedMenuFromList)
        setSelected([selectedMenuFromList])
      } else {
        dispatch(getCurrentMenu({ menuId: id, token }))
      }
    }
  }, [id, menuList, selectedMenu.id, token, dispatch])

  return (
    <div className={styles.mainPage}>
      <Navbar />
      <div className={styles.menuTitleBlock}>
        <div className={styles.menuSelectBlock}>
          <h2>Меню</h2>
        </div>
      </div>
      <div className={styles.createAndEdit}>
        <Select
          options={[
            ...menuList.map((item) => ({
              value: item.id,
              label: item.title,
            })),
          ]}
          value={
            selectedMenu.id
              ? {
                  value: selectedMenu.id,
                  label: menuList.find((item) => item.id === selectedMenu.id)?.title || '',
                }
              : null
          }
          onChange={(selectedOption) => {
            const newValue = selectedOption ? selectedOption.value : ''
            dispatch(clearCurrentCategory())
            handleSelectChange({
              target: { value: newValue },
            } as React.ChangeEvent<HTMLSelectElement>)
          }}
          className={styles.selectInput}
          classNamePrefix='react-select'
          isClearable={true}
          placeholder='Выбрать меню'
          noOptionsMessage={() => 'Нет доступных меню'}
          styles={{
            control: (provided) => ({
              ...provided,
              border: 'none',
              boxShadow: 'none',
              minHeight: 'auto',
              backgroundColor: 'transparent',
            }),
            menu: (provided) => ({
              ...provided,
              right: 0,
              overflow: 'auto',
              height: 'auto',
            }),
            input: (provided) => ({
              ...provided,
              margin: 0,
              padding: 0,
              height: isMobile ? 44 : 20,
            }),
            clearIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: 0,
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            indicatorSeparator: () => ({
              display: 'none',
            }),
          }}
        />
        <CustomButton
          iconSrc={isMobile ? plusIcon : ''}
          className={styles.addSiteBtn}
          title={isMobile ? '' : 'Создать меню'}
          type='button'
          onClick={() => setIsCartOpen(true)}
        />
      </div>

      <div className={styles.menuPageMain}>
        {isMobile ? (
          <div className={styles.mobileMenuContainer}>
            <div className={styles.mobileMenuWrapper}>
              {currentMenu.name && (
                <div className={styles.wrapperTitle}>
                  <h2>{selectedMenu.title}</h2>
                  {currentMenu.description !== 'undefined' && currentMenu.description !== null && (
                    <p className={styles.description}>{currentMenu.description}</p>
                  )}
                </div>
              )}
              {selectedMenu.title && (
                <CustomButton
                  ref={buttonRef}
                  onClick={() => setOpenControl(!openControl)}
                  iconSrc={iconKebab}
                  title=''
                  className={styles.editBtn}
                />
              )}
              {openControl && (
                <div ref={controlRef} className={styles.controlContainer}>
                  <div onClick={handleMenuEditMode} className={styles.controlItem}>
                    Редактировать меню
                  </div>
                  <div
                    onClick={() => setIsAddCategoryModalOpen(true)}
                    className={styles.controlItem}
                  >
                    Добавить категорию
                  </div>
                  <div onClick={handleEditMode} className={styles.controlItem}>
                    Редактировать категорию
                  </div>
                  <div onClick={() => setIsProductOpen(true)} className={styles.controlItem}>
                    Создать продукт
                  </div>
                  <div onClick={() => setIsCreateCategoryOpen(true)} className={styles.controlItem}>
                    Создать категорию
                  </div>
                </div>
              )}
            </div>
            <AddCategoriesModal
              isOpen={isAddCategoryModalOpen}
              onClose={() => setIsAddCategoryModalOpen(false)}
              selectedMenuId={selectedMenu.id}
              submited={() => setCatSubmited(true)}
            />
            <div className={styles.mobileCategoriesWrapper}>
              {selectedMenu.id ? (
                selectedMenu?.menuCategories?.length > 0 ? (
                  selected
                    .filter((item) => item.menuCategories && item.menuCategories.length > 0)
                    .map((item) =>
                      item.menuCategories.map((menuCategory: MenuCategory) => {
                        if (menuCategory?.category) {
                          return (
                            <span
                              key={menuCategory.category.id}
                              onClick={() => {
                                activeItem({
                                  id: menuCategory.category.id,
                                  title: menuCategory.category.name,
                                  subTitle: String(menuCategory.category.description),
                                })
                                _getCurrentCategory(menuCategory.category.id)
                              }}
                              className={
                                activeOption.id === menuCategory.category.id
                                  ? styles.activeCategoriesMobile
                                  : ''
                              }
                            >
                              {menuCategory.category.name}
                            </span>
                          )
                        }
                        return null
                      }),
                    )
                ) : (
                  <div style={{ width: '100%', textAlign: 'center', fontSize: '12px' }}>
                    Нет категорий
                  </div>
                )
              ) : (
                eventList.map((item) => (
                  <span
                    key={item.id}
                    onClick={() => {
                      activeItem({
                        id: item.id,
                        title: item.name,
                        subTitle: item.description,
                      })
                      _getCurrentCategory(item.id)
                    }}
                    className={
                      activeOption.title === item.title ? styles.activeCategoriesMobile : ''
                    }
                  >
                    {item.title}
                  </span>
                ))
              )}
            </div>
            <div className={styles.mobileDishesContainer}>
              <div className={styles.mobileTitle}>
                <div>
                  <h1>{activeOption.title}</h1>
                  {activeOption.subTitle && (
                    <p className={styles.titleDescription}>{activeOption.subTitle}</p>
                  )}
                </div>
              </div>
              <div className={styles.dishesBlock}>
                {currentCategory?.products?.length === 0 ? (
                  <div style={{ width: '100%', textAlign: 'center', marginBottom: 50 }}>
                    Список продуктов пуст...
                  </div>
                ) : (
                  currentCategory?.products?.map((dish) => {
                    return (
                      <DishesCard
                        id={dish.id}
                        key={dish.id}
                        name={dish.name}
                        price={Number(dish.price)}
                        weight={dish.weight}
                        images={dish.images.map((src, index) => ({ id: index, src }))}
                        quantity={1}
                        description={dish.description || ''}
                        measurement={dish.measurement}
                        category={dish.name}
                        menuId={selectedMenu.id}
                      />
                    )
                  })
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            {selectedMenu?.id && (
              <div className={styles.left}>
                <div className={styles.menuNameAndEdit}>
                  <div className={styles.selectedMenu}>
                    <div className={styles.wrapperTitle}>
                      <h2>{currentMenu.name}</h2>
                      {currentMenu.description !== 'undefined' &&
                        currentMenu.description !== null && (
                          <p className={styles.description}>{currentMenu.description}</p>
                        )}
                    </div>
                    {selectedMenu.title && (
                      <CustomButton
                        iconSrc={iconEdit}
                        className={styles.editBtn}
                        title=''
                        type='button'
                        onClick={handleMenuEditMode}
                      />
                    )}
                    <AddCategoriesModal
                      isOpen={isAddCategoryModalOpen}
                      onClose={() => setIsAddCategoryModalOpen(false)}
                      selectedMenuId={selectedMenu.id}
                      submited={() => setCatSubmited(true)}
                    />
                  </div>
                </div>
                <div className={styles.createCategoryBlock}>
                  <p className={styles.categoryTitle}>Категории</p>
                  {selectedMenu.title && (
                    <CustomButton
                      className={styles.editBtn}
                      title='Создать категорию'
                      type='button'
                      onClick={() => setIsCreateCategoryOpen(true)}
                    />
                  )}
                </div>
                <div className={styles.menuItems}>
                  <ul>
                    {currentMenu?.menuCategories ? (
                      currentMenu?.menuCategories?.length > 0 ? (
                        currentMenu.menuCategories.map((item: any) => {
                          if (item?.category) {
                            return (
                              <li
                                key={item.category.id}
                                onClick={() => {
                                  activeItem({
                                    id: item.category.id,
                                    title: item.category.name,
                                    subTitle: String(item.category.description),
                                  })
                                  _getCurrentCategory(item.category.id)
                                }}
                                className={
                                  activeOption.id === item.category.id ? styles.active : ''
                                }
                              >
                                {item.category.name}
                              </li>
                            )
                          }
                          return null
                        })
                      ) : (
                        <div style={{ width: '100%', textAlign: 'center', fontSize: '12px' }}>
                          Нет категорий
                        </div>
                      )
                    ) : (
                      eventList.map((item) => (
                        <li
                          key={item.id}
                          onClick={() => {
                            activeItem({
                              id: item.id,
                              title: item.name,
                              subTitle: item.description,
                            })
                            _getCurrentCategory(item.id)
                          }}
                          className={activeOption.title === item.title ? styles.active : ''}
                        >
                          {item.title}
                        </li>
                      ))
                    )}
                    {/* <div className={styles.buttonContainer}>
                    {selectedMenu.id && (
                      <CustomButton
                        className={styles.addCategory}
                        title='Добавить категории'
                        type='button'
                        onClick={() => setIsAddCategoryModalOpen(true)}
                      />
                    )}
                  </div> */}
                  </ul>
                </div>
              </div>
            )}
            <div className={styles.right}>
              <div className={styles.dishes}>
                <div className={styles.title}>
                  <div style={{ width: '100%' }}>
                    <h1>{activeOption.title}</h1>
                    {activeOption.subTitle && (
                      <p className={styles.titleDescription}>{activeOption.subTitle}</p>
                    )}
                  </div>
                  {activeOption.title && (
                    <div className={styles.addProductButton}>
                      <CustomButton
                        iconSrc={iconEdit}
                        className={styles.editBtn}
                        title=''
                        type='button'
                        onClick={handleEditMode}
                      />
                      <CustomButton
                        className={styles.editBtn}
                        title='Создать продукт'
                        type='button'
                        onClick={() => {
                          setIsProductOpen(true)
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className={styles.dishesBlock}>
                  {currentCategory?.products?.length === 0 ? (
                    <div style={{ width: '100%', textAlign: 'center', marginBottom: 50 }}>
                      Список продуктов пуст...
                    </div>
                  ) : (
                    currentCategory?.products?.map((dish) => {
                      return (
                        <DishesCard
                          id={dish.id}
                          key={dish.id}
                          name={dish.name}
                          price={Number(dish.price)}
                          weight={dish.weight}
                          images={dish.images.map((src, index) => ({ id: index, src }))}
                          quantity={1}
                          description={dish.description || ''}
                          measurement={dish.measurement}
                          category={dish.name}
                          menuId={selectedMenu.id}
                        />
                      )
                    })
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <CreateCategoryModal
        menuId={selectedMenu.id}
        currentCat={currentCategory}
        isEditMode={editMode}
        isOpen={isCreateCategoryOpen || editMode}
        onClose={() => {
          setIsCreateCategoryOpen(false)
          setEditMode(false)
        }}
      />
      <CreateMenuModal
        isEditMode={isMenuEditing}
        isOpen={isCartOpen || isMenuEditing}
        onClose={() => {
          setIsCartOpen(false)
          setIsMenuEditing(false)
        }}
        currentMenu={currentMenu}
      />

      <CreateProductModal
        menuId={selectedMenu.id}
        isReadOnlyMode={false}
        isEditMode={false}
        isOpen={isProductOpen}
        onClose={() => {
          setIsProductOpen(false)
          setEditMode(false)
          dispatch(resetCurrentProduct())
        }}
        currentCat={currentCategory}
      />
    </div>
  )
}

export default MenuPage
